function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 70,
  fill: "#0085FF",
  fillOpacity: 0.08
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#empty-wages-state_svg__filter0_d_1326:7555)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 35,
  y: 76,
  width: 138,
  height: 18,
  rx: 1.532,
  fill: "#fff"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fill: "#A0AFBE",
  d: "M52 81h116v8H52z"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 84.5,
  r: 12.5,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 84.5,
  r: 11.5,
  fill: "#DBDFE5"
});
var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-wages-state_svg__a)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 96,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 80.841,
  r: 5.662,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#empty-wages-state_svg__filter1_d_1326:7555)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 35,
  y: 48,
  width: 138,
  height: 18,
  rx: 1.532,
  fill: "#fff"
}));
var _ref8 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fill: "#A0AFBE",
  d: "M52 53h116v8H52z"
});
var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 56.5,
  r: 12.5,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref0 = /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 56.5,
  r: 11.5,
  fill: "#DBDFE5"
});
var _ref1 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-wages-state_svg__b)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 68,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 52.841,
  r: 5.662,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "empty-wages-state_svg__filter0_d_1326:7555",
  x: 27,
  y: 70,
  width: 154,
  height: 34,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1326:7555"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_1326:7555",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "empty-wages-state_svg__filter1_d_1326:7555",
  x: 27,
  y: 42,
  width: 154,
  height: 34,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1326:7555"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_1326:7555",
  result: "shape"
})));
function SvgEmptyWagesState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 140,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, /*#__PURE__*/React.createElement("mask", {
    id: "empty-wages-state_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 73,
    width: 23,
    height: 23
  }, _ref5), _ref6, _ref7, _ref8, _ref9, /*#__PURE__*/React.createElement("mask", {
    id: "empty-wages-state_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 45,
    width: 23,
    height: 23
  }, _ref0), _ref1, _ref10);
}
export default SvgEmptyWagesState;